import TranslationSendItemsView from 'components/SendItems/TranslationSendItemsView';

const TranslationSendItems = () => {
  return <TranslationSendItemsView />;
};

export default TranslationSendItems;
